// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/node_modules/.pnpm/@ant-design+icons@4.8.3_rea_68e2a414ecd570b4ddf522b637fda0f9/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import SmileOutlined from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/node_modules/.pnpm/@ant-design+icons@4.8.3_rea_68e2a414ecd570b4ddf522b637fda0f9/node_modules/@ant-design/icons/es/icons/SmileOutlined';
export default { DashboardOutlined, SmileOutlined };
